import { Component } from '@angular/core';
import { BaseComponent } from '../../base.component';
import { Router } from '@angular/router';
import { FeatureHelperService } from '../../_helpers/feature-helper/feature-helper.service';
import { AuthenticationStateHelperService } from '../../_helpers/authentication-state-helper/authentication-state-helper.service';

@Component({
    selector: 'client-landing',
    templateUrl: 'client-landing.component.html',
    styleUrls: ['client-landing.component.css'],
    standalone: false
})

export class ClientLandingComponent extends BaseComponent {

  public companyUrl: string = "teachingpersonnel";

  public onlineTuitionSupported: boolean = false;

  constructor(
    public router: Router,
    private featureHelperService: FeatureHelperService,
    private authenticationStateHelper: AuthenticationStateHelperService,
    ) {
    super();

    let featureList = new Array<string>();
    featureList.push("ClientHomeView");

    let currentUserFeatures = this.featureHelperService.checkFeaturePermissions(featureList);

    if (!currentUserFeatures.filter(f => f.feature === "ClientHomeView")[0].enabled) {
      console.error("User does not have the required permissions to view the client landing screen");
      this.router.navigate(['/login'], { queryParams: { returnUrl: window.location.pathname }});
      this.authenticationStateHelper.unauthorizedToken = true;
    }

    this.onlineTuitionSupported = this.isBrambleReadyBrowser();
  }

  private isBrambleReadyBrowser(): boolean {
    //full chrome
    const chrome = window["chrome"];
    if (chrome && chrome.app && Object.keys(chrome.app).length > 1)
        return true;

    let ua = window.navigator.userAgent;
    let ios22 = /iPad/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    let webkit = !!ua.match(/WebKit/i);
    let iOSSafari = ios22 && webkit && !ua.match(/CriOS/i);
    if (iOSSafari){
        return true;
    }

    let chromeOther = /Chrome\W\d/.test(ua);
    let android = /Android\W\d/.test(ua);
    if (chromeOther && android) {
        return true; 
    }
    
    let agent = ua.toLowerCase();
    switch (true) {
        case agent.indexOf("edge") > -1: return false;
        case agent.indexOf("edg") > -1: return true;
        default: return false; //everything else is a no 
    }
  } 

}
